<ion-toolbar
  [color]="toolbarColor"
  class="first ion-text-center"
  style="padding-top: 0"
>
  <div style="width: 50px; max-width: 60px; margin-left: 5px">
    <img src="assets/sen3i-logo.png" alt="" />
  </div>
  <!-- <ion-container>
    <img
      src="assets/emas_bse_trimmed.png"
      style="cursor: pointer; height: 40px; margin-top: 5px"
      alt=""
      (click)="handleRedirectToHomePage()"
    />
  </ion-container> -->
  <ion-buttons slot="end" [color]="constrastColor">
    <ion-button
      mode="ios"
      [color]="constrastColor"
      class="icon-default"
      id="open-modal"
      expand="block"
      (click)="handleRedirectToProfile()"
    >
      <div class="profile-icon-container">
        <ion-icon
          name="person-circle-outline"
          style="font-size: 1.625rem"
        ></ion-icon>
        <span
          *ngIf="isShowUserStatus"
          class="status-dot"
          [ngClass]="userStatus?.class"
        >
        </span>
      </div>
    </ion-button>
    <div style="position: relative">
      <ion-button
        mode="ios"
        [color]="constrastColor"
        class="icon-default"
        id="open-modal"
        expand="block"
        (click)="handleShowNotifications()"
      >
        <ion-icon name="notifications" style="margin: 0px"></ion-icon>
        <div class="notification-badge" *ngIf="totaUnreadlNotifications">
          <div class="red-circle" *ngIf="totaUnreadlNotifications !== '0'">
            {{ totaUnreadlNotifications }}
          </div>
        </div>
      </ion-button>
    </div>
    <ion-button 
      mode="ios"
      [color]="constrastColor"
      class="icon-default"
      expand="block"
      *ngIf="isKioskMode"
      (click)="openSubMenu($event)"
      >
       <ion-icon name="settings-outline" style="margin: 0px"></ion-icon>
    </ion-button>
    <ion-menu-button class="icon-default" auto-hide="true"></ion-menu-button>
  </ion-buttons>
</ion-toolbar>
